<template>
	<div class="row mt-3"> 
		<div 
			:class="(windowWidth > 1000) ? 'col-10' : 'col-12'"
			class=" text-gray text-14 d-flex align-items-center shadow p-3"
			style="background: #FAA61A1A; border-radius: 10px;"	
		>
		تیکت شما بسته شده است. در صورتی که نیاز به پشتیبانی دارید تیکت جدید ایجاد کنید.
		</div>
		<div :class="(windowWidth > 1000) ? 'col-2' : 'col-12 p-0 mt-3'" style="display: flex; align-items: center;">
			<router-link to="/ticket/create" class="w-100">
				<btn 
				text="+ تیکت جدید"
				textClass="w-100"
				/>
			</router-link>
		</div>
	</div>
</template>

<script>
	import btn from  "../../UI/button/btn.vue";

	export default {
		name: 'ticket_create_part2',
		data(){
			return {

			}
		},
		components: {
			btn,
		},
		props: {
			flds: {
				default: [],
			},
		},
		mounted(){

		},
		methods:{
			
		}
	}
</script>
